kimal.$selectmenu = $('#header-select');
kimal.$getInTouchSelect = $('#get-in-touch-select');
kimal.$currentLocale = $('#current-locale');

if (kimal.$selectmenu.length) {
  kimal.$selectmenu.selectmenu({
    open: function(event, ui) {
      $(".ui-menu-item")[0].remove();
    },
    close: function(event) {
      $(this).selectmenu("refresh");
    },
    select: function(event, ui) {
      if (ui.item.value.match(/https?:\/\//)) {
        document.location.href = ui.item.value;
      }
    }
  }).data("ui-selectmenu")._renderItem = function(ul, item) {
    var li = "<li class='language-select__item'>";

    li += '<span class="flag-icon flag-icon-' + item.element[0].label + '"> </span>';
    li += item.label;
    li += '</li>';

    return $(li).appendTo( ul );

  }
}

kimal.$currentLocale.click(function() {
    kimal.$selectmenu.selectmenu('open');
});

if(kimal.$selectmenu.length > 0 || kimal.$getInTouchSelect.length > 0) {
  kimal.$window.on('resize', function() {
    kimal.$selectmenu.selectmenu('close');
    kimal.$getInTouchSelect.selectmenu('close');
  });
}

kimal.$getInTouchSelect.hide();
kimal.$getInTouchSelect.each(function(index) {
  var $select = $(this), numberOfOptions = $(this).children('option').length;

  $select.addClass('select-hidden');
  $select.wrap('<div class="selectmenu"></div>');
  $select.after('\
    <div class="selectmenu__button">\
      <span class="selectmenu__button___text"></span>\
      <span class="selectmenu__button___icon"></span>\
    </div>'
  );

  var $styledSelectText = $('.selectmenu__button___text');
  var $styledSelect = $select.next('div.selectmenu__button');
  $styledSelectText.text($select.children('option').eq(0).text());

  var $list = $('<ul />', {
    'class': 'selectmenu__options'
  }).insertAfter($styledSelect);

  for (var i = 1; i < numberOfOptions; i++) {
    $('<li />', {
      text: $select.children('option').eq(i).text(),
      rel: $select.children('option').eq(i).val(),
      'data-locale': $select.children('option').eq(i).val(),
      id: $select.children('option').eq(i).val()

    }).appendTo($list);
  }

  var $listItems = $list.children('li');

  $styledSelect.click(function(e) {
    e.stopPropagation();

    $('div.select-styled.active').not(this).each(function(){
      $(this).removeClass('active').next('ul.selectmenu__options').hide();
    });

    $(this).toggleClass('active').next('ul.selectmenu__options').toggle();
  });

  $listItems.click(function(e) {
    e.stopPropagation();

    var $this = $(this);

    $styledSelectText.text($this.text()).removeClass('active');
    $select.val($this.attr('rel'));

    var locale = $this.attr('data-locale');
    $('.contact-details__locale').fadeOut(function() {
      setTimeout(function() {
        $('.contact-details__locale[data-locale="' + locale + '"]').fadeIn();
      });
    })

    $list.hide();
  });

  $(document).click(function() {
    $styledSelect.removeClass('active');
    $list.hide();
  });
});;
